import { useTranslation } from 'react-i18next';

interface OperatorNoteProps {
  note?: string | null;
  className?: string;
}

export function OperatorNote({ note, className }: OperatorNoteProps) {
  const { t } = useTranslation();

  if (!note) return null;

  return (
    <div
      className={`flex items-start gap-3 p-3 bg-monta-blue/5 border border-monta-blue/15 rounded-lg ${className ?? ''}`}
      data-testid="operator-note"
    >
      <svg
        className="w-5 h-5 text-monta-blue flex-shrink-0 mt-0.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-muted uppercase tracking-wide">
          {t('chargePoint.noteFromOperator')}
        </p>
        <p className="text-sm text-ink mt-1 whitespace-pre-line">{note}</p>
      </div>
    </div>
  );
}
